import { createReducer } from '@reduxjs/toolkit'
import { ILanguage } from 'shared/types'
import { receiveLanguages } from 'src/model/actions'

const initialState = null as Record<string, ILanguage> | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveLanguages, (state, action) => action.payload)
})

export default reducer
